<template>
  <m-button
      class="action-button"
      purple
      :disabled="disabled"
      v-on="$listeners"
  >
    <template #text>
              <span class="big-text mx-8">
                {{ text }}
              </span>
    </template>
  </m-button>
</template>

<script>
export default {
  name: "m-confirm-button",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.big-text {
  font-family: Open Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
}
</style>